// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2NoIS","card":"Cards_card__DpVV7","infected":"Cards_infected__1pQ9I","recovered":"Cards_recovered__2QPmV","deaths":"Cards_deaths__264bb"};